import React, { useState } from 'react';
import { Link , useLocation, useHistory} from 'react-router-dom';
import PageContainer from 'publish/layout/PageContainer';
import LayoutAside from "../adm_mypageAside";
import Button from 'components/buttons/';
import UIInput from 'components/input/input';
import UIInputPW from 'components/input/inputPW';
import CommonUtil from "utils/CommonUtil";
import StringUtil from "utils/StringUtil";
import userStore from "common/user/store/UserStore";
import UIUtils from "utils/UIUtils";
import ValidationUtil from "common/validation/util/ValidationUtil";
import UI from "components/UI";
import message from "common/message/source/MessageSource";

function ContentsContainer() {

	const [userId, setUserId] = useState('');
	const [personId, setPersonId] = useState('');
	const [bizNo, setBizNo] = useState('');
	const [corpNm, setCorpNm] = useState('');
	const [loginNm, setLoginNm] = useState('');
	const [personNm, setPersonNm] = useState('');
	const [emailAdres, setEmailAdres] = useState('');
	const [deptNm, setDeptNm] = useState('');
	const [posiNm, setPosiNm] = useState('');
	const [hpNo, setHpNo] = useState('');
	const [ofcTelNo, setOfcTelNo] = useState('');
	const [loginPassword ,setLoginPassword] = useState(null);
	const [confirmPassword ,setConfirmPassword] = useState(null);

	const mypageForm = React.useRef<HTMLFormElement>(null);
	const [errorCode, setErrorCode] = React.useState<string>("");
	const formId = "mypageForm";
	let vPersonId = userStore.userModel?.getPersonId();

	let userTpCd:string = "";
	// //사용자 유형 
	 if(userStore.userModel?.getTbComPerson().userTpCd !=undefined){
		userTpCd = String(userStore.userModel?.getTbComPerson().userTpCd);
	 }
	
	// 상세 데이터 가져오기
	async function initCall(paramPersonId){
		let param = {
			"PERSON_ID": paramPersonId
		};

		const response:any = await CommonUtil.execute({
			url:'adm_4110_detail',
			data: param,
			progressBar:true
		}).then((response: any) => {
			const result = response;
			if(response !=null){
				setLoginNm(result.LOGIN_NM)
				setPersonNm(result.PERSON_NM);
				setDeptNm(result.DEPT_NM);
				setPosiNm(result.POSI_NM);
				setBizNo(result.BIZ_NO);
				setCorpNm(result.CORP_NM);
				setHpNo(result.HP_NO);
				setEmailAdres(result.EMAIL_ADRES);
				setOfcTelNo(result.OFC_TEL_NO); 
				setUserId(result.USER_ID);
				setPersonId(result.PERSON_ID);	
			}		
    	}).catch((error) => {
        	CommonUtil.showAxiosError(error);
        	return;
    	});	  

	};

	const checkPassword = (value: any) => {
		let message = '';
	
		if (value == null || (value + "").length === 0) {
		  return message;
		}
		if (value.length < 8) {
		    message = `8자리 이상 입력해 주세요.`;
	
		  return message;
		}
	
		// const regExp = /(?=.*\d{1,50})(?=.*[~`!@#$%\\^&*()-+=]{1,50})(?=.*[a-zA-Z]{1,50}).{8,50}$/;
		const regExp = new RegExp('^(?=.*[a-zA-Z])(?=.*[0-9])(?=.*[~`\'":;,.!@#$%^&*()-+=_]).{8,}$');
	
		if (!regExp.test(value)) {
		  message = `영문, 숫자, 특수문자를 혼합하여 입력해 주세요.`;
	
		  return message;
		}
	
		return message;
	  }

	//사용자 등록 저장
    async function onClickSave(event) {
    	event.preventDefault();		

		if(ValidationUtil.checkAll()) {
			// 검증이 유효하지 않은 경우
			return;
		}

		if(loginPassword !== confirmPassword){
			await UIUtils.alert("비밀번호가 일치하지 않습니다.");
			return;
		}else{
			let resMsg ='';
			if(loginPassword !=''){
				resMsg = checkPassword(loginPassword);
				if(resMsg != ''){
					await UIUtils.alert(resMsg);
					return;
				}
			}
	
			if(confirmPassword !=''){
				resMsg = checkPassword(confirmPassword);
				if(resMsg != ''){
					await UIUtils.alert(resMsg);
					return;
				}
			}
		}

		if ( (posiNm == null || posiNm == "") 
		    || (deptNm == null || deptNm == "") 
			|| (hpNo == null || hpNo == "") 
			|| (emailAdres == null || emailAdres == "") ) 
		{
			await UIUtils.alert("* 항목은 필수입력입니다.");
			return;
		}
		

		let param = {
			PERSON_ID:personId
			,LOGIN_NM:loginNm
			,USER_ID:userId
			,EMAIL_ADRES:emailAdres
			,PERSON_NM:personNm
			,CHANGE_PSN_ID:""
			,DEPT_NM:deptNm
			,POSI_NM:posiNm
			,OFC_TEL_NO:ofcTelNo
			,HP_NO:hpNo
			,LOGIN_PASSWORD:loginPassword
		}

		if(await UIUtils.confirm(message.get("common.message.save.confirm", "저장하시겠습니까?"))){
			const response:any = await CommonUtil.execute({
				url: "adm_mypage_update.jct",
				form: mypageForm.current as HTMLFormElement
			}).then((response:any) => {
				if(response){
					UIUtils.alert('저장되었습니다.').then();
					setLoginPassword(null);
					setConfirmPassword(null);
					initCall(vPersonId);
				}
	
				
			}).catch(err => {
				CommonUtil.showAxiosError(err);
				return;
			});



			// const response:any = await CommonUtil.execute({
			// 	url:"adm_mypage_update",
			// 	//data: param
			// 	form: mypageForm.current as HTMLFormElement,
			// }).then((response: any) => {
			// 	if(response){
			// 		UIUtils.alert('저장되었습니다.').then();
			// 		setLoginPassword(null);
			// 		setConfirmPassword(null);
			// 		initCall(vPersonId);
			// 	}
			// }).catch((error) => {
			// 	CommonUtil.showAxiosError(error);
			// 	return;
			// });	 
		}
    };  

	//init
	React.useEffect(() => {
		//상세데이터 가지고 오기
		initCall(vPersonId);
		
    },[])
	return (
		<PageContainer>
			<LayoutAside />
			<div className='fww-con'>
				<ul className="fww-brd">
					<li><Link to="/admin/">홈</Link></li>
					<li><Link to="#">관리자페이지</Link></li>
					<li><Link to="#">마이페이지</Link></li>
				</ul>
				<main className="fww-main">
					<h1 className="tx tx-hd2">내정보 수정</h1>
					<form className="fo fo-col2" id={formId} name={formId} ref={mypageForm}>
						<div className="inner">
							<div className="fo-item">
								<p className="fo-key">기업명</p>
								<div className="fo-value">
									<UIInput className={'tf tf-md w100p'} value={"[" + StringUtil.bizCrpFormat(bizNo) + "]" + corpNm} placeholder={''} readOnly={true}  />
								</div>
							</div>
							<div className="fo-item req">
								<p className="fo-key">사용자ID</p>
								<div className="fo-value">
									<UIInput className={'tf tf-md w100p'} value={loginNm} placeholder={''} readOnly={true}  />
								</div>
							</div>
							<div className="fo-item req">
								<p className="fo-key">이름</p>
								<div className="fo-value">
									<UIInput className={'tf tf-md w100p'}  value={personNm} valueChanged={(value) => setPersonNm(value)} placeholder={'이름'} readOnly={userTpCd=='N'?true:false} rules={["required"]} attrs={{name:"PERSON_NM"}}/>
								</div>
							</div>
							<div className="fo-item req">
								<p className="fo-key">이메일</p>
								<div className="fo-value">
									<UIInput className={'tf tf-md w100p'} value={emailAdres} valueChanged={(value) => setEmailAdres(value)} placeholder={'이메일'} readOnly={userTpCd=='N'?true:false} rules={["required"]} attrs={{name:"EMAIL_ADRES"}}/>
								</div>
							</div>
							<div className="fo-item req">
								<p className="fo-key">부서</p>
								<div className="fo-value">
									<UIInput className={'tf tf-md w100p'} value={deptNm} valueChanged={(value) => setDeptNm(value)} placeholder={'부서'} readOnly={false} rules={["required"]} attrs={{name:"DEPT_NM"}}/>
								</div>
							</div>
							<div className="fo-item req">
								<p className="fo-key">직급</p>
								<div className="fo-value">
									<UIInput className={'tf tf-md w100p'} value={posiNm} valueChanged={(value) => setPosiNm(value)} placeholder={'직급'} readOnly={false} rules={["required"]} attrs={{name:"POSI_NM"}}/>
								</div>
							</div>
							<div className="fo-item req">
								<p className="fo-key">휴대폰번호</p>
								<div className="fo-value">
									<UIInput type='number' className={'tf tf-md w100p'} value={hpNo} valueChanged={(value) => setHpNo(value)} placeholder={'-없이 숫자만'} readOnly={userTpCd=='N'?true:false} rules={["required"]} attrs={{name:"HP_NO"}}/>
								</div>
							</div>
							<div className="fo-item">
								<p className="fo-key">사무실전화번호</p>
								<div className="fo-value">
									<UIInput type='number' className={'tf tf-md w100p'} value={ofcTelNo} valueChanged={(value) => setOfcTelNo(value)} placeholder={'-없이 숫자만'} readOnly={false} attrs={{name:"OFC_TEL_NO"}} />
								</div>
							</div>
							<UI.If test = {userTpCd !== "N" }>	
							<div className="fo-item fo-m-1-3 req">
									<p className="fo-key">비밀번호</p>
									<div className="fo-value">
										<div className="hz-root hz-gap8">
											<UIInputPW
                                                className={'tf tf-big w100p'}
                                                placeholder={'수정할 때만 입력해주세요.'}
                                                attrs={{
                                                    name: "LOGIN_PASSWORD",
                                                    alt: "Password",
                                                    tabIndex: 1,
                                                    autoComplete: "on",
                                                }}
                                                readOnly={false}
                                                valueChanged={(value) => setLoginPassword(value)}
                                               // rules={["required","password"]}
                                                focusClear={true}
                                            />
										</div>
										<span className="fc-err">&nbsp;&nbsp;※ 8~12자의 영문, 숫자, 특수문자 조합으로 입력해 주세요.</span>
									</div>
									
								</div>
								<div className="fo-item fo-m-1-3 req">
									<p className="fo-key">비밀번호 확인</p>
									<div className="fo-value">
										<div className="hz-root hz-gap8">
										    <UIInputPW
                                                className={'tf tf-big w100p'}
                                                placeholder={'수정할 때만 입력해주세요.'}
                                                attrs={{
                                                    name: "CONFIRM_PASSWORD",
                                                    alt: "Password",
                                                    tabIndex: 2,
                                                    autoComplete: "on",
                                                }}
                                                readOnly={false}
                                                valueChanged={(value) => setConfirmPassword(value)}
												//rules={["required","password"]}
                                                focusClear={true}
                                            />
										</div>
										<span className="fc-err">&nbsp;&nbsp;※ 8~12자의 영문, 숫자, 특수문자 조합으로 입력해 주세요.</span>
									</div>
								
								</div>		
								</UI.If>
							
						</div>
					</form>
					<div className="hz-root hz-right hz-gap5">
						<Button color="pri-o" size="sm" onClick={(e)=>{onClickSave(e)}} >저장</Button>
					</div>
				</main>
			</div>
		</PageContainer>
	);
}
export default ContentsContainer;